import React, {PropTypes} from 'react';
import Nouislider from 'react-nouislider';

class Menu extends React.Component {

  componentDidMount () {
    window.current_month = 1;

    // Hack to access Menu's methods from inside the anonymous functions bellow
    let that = this;

    // If no modal to open, autoplay
    if(!window.location.hash) {
      //Hack to prevent a strange "skipping" effect from position 1 to 2
      that.refs.NoUiSlider.slider.set(1);

      // Wait 1.5 seconds so that the map has the time to load
      setTimeout(function(){
        // Start the autoplay
        window.autoplayInterval = setInterval(that.autoplay, 1800);
        window.autoplayIntervalIsRunning = true;
      }, 1000);
    }

    // Autoplay
    window.addEventListener('update', function () {
      let current_month = window.current_month;

      // The visual effect during autoplay is like if we clicked, so simulate a transition
      that.slidingStartsNow();

      // Move the slider where it should be
      that.refs.NoUiSlider.slider.set(current_month);

      // Update the label
      that.labelSlidertipDelayed(current_month);

      // Update the map
      that.updateMapDelayed(current_month);
    }, false);

    this.attachLabel();

    // Handle left/right arrow keys
    $(document).keydown(function(e) {
      that.autoplayStop();

      switch(e.which) {
        case 37: // left
        that.playPrevious();
        break;

        case 39: // right
        that.autoplay();
        break;

        case 27: // ESC
        that.props.selectionActions.hideInfobox();
        that.props.selectionActions.hideSelection();
        break;

        default: return; // exit this handler for other keys
      }
      e.preventDefault(); // prevent the default action (scroll / move caret)
    });

    this.unHideSliderHandle();
  }

  // This only for when the autoplay is stopped from outside this component!
  componentDidUpdate () {
    this.unHideSliderHandle();

    this.attachLabel();

    if (!this.props.autoplay.autoplay) {
      this.autoplayStop();
    }
    else {
      // Force to start here?
    }
  }

  // Prevents a flickering bun on Safari.
  // The handle is hidden by default in the css, and displayed only when the code has loaded
  // With a delay, but not for chrome
  unHideSliderHandle () {
    let ua = navigator.userAgent.toLowerCase();
    window.requestAnimationFrame(function() {
      if(ua.indexOf('chrome') !== -1) {
        $('.slidertip').css('visibility', 'visible')
        $('.noUi-handle').css('visibility', 'visible')
      }
      else {
        setTimeout(function(){
          $('.slidertip').css('visibility', 'visible')
          $('.noUi-handle').css('visibility', 'visible')
        }, 0);
      }
    });
  }

  slidingStartsNow () {
    // Flag up
    window.isSliding = true;
    // The sliding lasts 300ms
    setTimeout(function(){
      // Flag down
      window.isSliding = false;
    }, 300);
  }

  autoplay () {
    let next_month = window.current_month + 1;
    if (next_month === 13) next_month = 1;

    var event = new Event('update');
    window.current_month = next_month;
    window.dispatchEvent(event);
  }

  playPrevious () {
    let previous_month = window.current_month - 1;
    if (previous_month === 0) previous_month = 12;

    var event = new Event('update');
    window.current_month = previous_month;
    window.dispatchEvent(event);
  }

  autoplayStop () {
    if (window.autoplayIntervalIsRunning) {
      clearInterval(window.autoplayInterval);
      window.autoplayIntervalIsRunning = false;
    }
  }

  isMobileDevice () {
    let ua = navigator.userAgent.toLowerCase();
    return (typeof window.orientation !== "undefined") || ua.indexOf('iemobile') !== -1;
  }

  onSlide (sliderValue) {
    let selectedMonth = Math.round(sliderValue[0]);

    window.current_month = selectedMonth;

    //Stop, if needed only
    this.autoplayStop();

    // On desktop, we can aford to refresh as the user is dragging the slider, so we do!
    if(!this.isMobileDevice()) {
      this.updateMapDelayed(selectedMonth);
    }

    this.labelSlidertipDelayed(selectedMonth);
  }

  onChange (sliderValue) {
    this.slidingStartsNow();

    //Stop, if needed only
    this.autoplayStop();

    // If we are on a mobile device, the map refresh above has not been trigered
    // Now is the time
    if(this.isMobileDevice()) {
      let selectedMonth = Math.round(sliderValue[0]);
      //this.labelSlidertip(selectedMonth);
      //this.props.selectionActions.selectMonth(selectedMonth);
      this.updateMapDelayed(selectedMonth);
    }
  }

  attachLabel () {
    // Attach our custom label to the slider
    $(".noUi-handle").append("<div class='slidertip'><div class='slidertip-label'></div></div>");
    this.labelSlidertip(window.current_month);
  }

  labelSlidertip (selectedMonth) {
    let labels = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    let label_index = selectedMonth - 1;
    let current_label = labels[label_index];

    $('.slidertip-label').text(current_label);
  }

  labelSlidertipDelayed (selectedMonth) {
    let that = this;
    // Respect a delay if a transition is happening
    // Wait just enough for the isTransitioning flag to be eventually available first
    setTimeout(function(){
      if (window.isSliding) {
        //Transition, we need to wait to be mid-way to change the label
        setTimeout(function(){
          that.labelSlidertip(selectedMonth);
        }, 80);
      }
      else {
        // Instant, go update label immediately
        that.labelSlidertip(selectedMonth);
      }
    }, 20);
  }

  // Respectfull trigger a call to that.props.selectionActions.selectMonth
  // If it's not been done many times in the past 50ms already
  // And if the slider is not currently sliding
  updateMapDelayed (selectedMonth) {
    clearInterval(this.updateMapTimeout);
    let that = this;

    // Wait 50 ms to be able to "compact" requests arriving at the same time because of quick sliding
    this.updateMapTimeout = setTimeout(function(){
      if (window.isSliding) {
        // Currently in a sliding animation, we need to wait for the animation to end to refresh the map
        setTimeout(function(){
          that.props.selectionActions.selectMonth(selectedMonth);
        }, 251);
      }
      else {
        // Instant, update map immediately
        that.props.selectionActions.selectMonth(selectedMonth);
      }
    }, 50);
  }

  render() {
    // https://refreshless.com/nouislider/slider-options/
    //animate = {false}

    let nouislider = (
      <Nouislider
        start = {[window.current_month]}
        step = {1}
        range = {{'min': 1, 'max': 12 }}
        onSlide = {this.onSlide.bind(this)}
        onChange = {this.onChange.bind(this)}
        ref="NoUiSlider"
      />
    )

    return (
      <div className="menu-container ">
        <div className="logo-container">
          <strong>Climate</strong> List <span className="badge beta">beta</span>
        </div>
        <div className="logo-container-mobile">
          <a data-toggle="modal" data-target="#about" href="#about">
            <img src={require('../images/about.png')} alt="" height="42" width="42" />
          </a>
        </div>
        <div className="links-container">
          <div className="fb-like-container">
            <div className="fb-like" data-href="https://www.facebook.com/climatelist/" data-width="200" data-layout="button" data-action="like" data-size="small" data-show-faces="false" data-share="false"></div>
          </div>
          <a data-toggle="modal" data-target="#about" href="#about">About</a> &nbsp; &nbsp; &nbsp;&nbsp;
          <span className="hidden-sm hidden-xs">
            <a href="https://blog.climatelist.com" target="_blank">Blog</a> &nbsp; &nbsp; &nbsp;&nbsp;
          </span>
          <a data-toggle="modal" data-target="#share" href="#share">Share</a>
        </div>
        <div className="links-container-mobile">
          <a data-toggle="modal" data-target="#share" href="#share">
            <img src={require('../images/share.png')} alt="" height="42" width="42" />
          </a>
        </div>
        <div className="slider-container">
          <div id="slider">
            {nouislider}
          </div>
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  autoplay: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired,
  autoplayActions: PropTypes.object.isRequired
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/Menu.js
 **/